<template>
	<div class="BaseArticleMasterTable">
		<!-- <simplebar class="simplebar">
			<table class="tableMain">
				<thead>
					<tr>
						<th colspan="1" class="border-right">
							Item Description
						</th>
						<th colspan="1" class="border-right">
							Item Code
						</th>
						<th
							v-if="applicationSelected == 'articleMaster'"
							colspan="1"
							class="border-right"
						>
							Stock Comes from
						</th>
						<th
							v-if="applicationSelected == 'articleMaster'"
							colspan="1"
							class="border-right"
						>
							Forecast Type
						</th>
						<th colspan="1" class="border-right">
							Item Type
						</th>
						<th colspan="1" class="border-right">
							Department
						</th>
						<th colspan="1" class="border-right">
							Category
						</th>
						<th colspan="1" class="border-right">
							Sub Category
						</th>
						<th
							v-if="applicationSelected == 'articleMaster'"
							colspan="1"
							class="border-right"
						>
							Order Unit
						</th>
						<th
							v-if="applicationSelected == 'articleMaster'"
							colspan="1"
							class="border-right"
						>
							Contains Each(Base)
						</th>
						<th
							v-if="applicationSelected == 'articleMaster'"
							colspan="1"
							class="border-right"
						>
							Base Unit
						</th>
						<th
							v-if="applicationSelected == 'articleMaster'"
							colspan="1"
							class="border-right"
						>
							Primary Shelf life
						</th>
						<th
							v-if="applicationSelected == 'articleMaster'"
							colspan="1"
							class="border-right"
						>
							Secondary Shelf life
						</th>
						<th
							v-if="applicationSelected == 'articleMaster'"
							colspan="1"
							class="border-right"
						>
							Ordering Frequency
						</th>

						<th
							v-if="applicationSelected == 'articleMaster'"
							colspan="1"
							class="border-right"
						>
							Lead Time
						</th>
						<th
							v-if="applicationSelected == 'articleMaster'"
							colspan="1"
							class="border-right"
						>
							Service Level
						</th>
						<th
							v-if="applicationSelected == 'articleMaster'"
							colspan="1"
							class="border-right"
						>
							Min Stock Level
						</th>
						<th
							v-if="applicationSelected == 'articleMaster'"
							colspan="1"
							class="border-right"
						>
							Current Cost
						</th>
						<th colspan="1" class="border-right">
							Sales Price
						</th>
						<th
							v-if="applicationSelected == 'articleMaster'"
							colspan="1"
							class="border-right"
						>
							Status
						</th>
						<th v-if="editIngredient" style="width: 100px;">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</th>
						<th style="width: 100px;">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(article, index) in articleMaster" :key="article.id">
						<td>
							<BaseInput
								v-model="article.itemDescription"
								v-validate="slecteIndex == index ? 'required' : ''"
								style="min-width: 180px;"
								:name="`Item Description ${index}`"
								class="baseInput"
								custom-class="p-2 text-sm text-amp-input-boxes"
								placeholder="Item Description"
							/>
							<span
								:v-show="errors.has(`Item Description ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Item Description ${index}`) }}
							</span>
						</td>
						<td>
							<BaseInput
								v-model="article.itemCode"
								v-validate="
									slecteIndex == index
										? {
												alpha_num: true,
												unique: [articleMaster, index]
										  }
										: ''
								"
								style="min-width: 120px;"
								:disabled="article.disableItemCode"
								:name="`Item Code ${index}`"
								class="baseInput"
								custom-class="p-2 text-sm text-amp-input-boxes"
								placeholder="Item code"
							/>
							<span
								:v-show="errors.has(`Item Code ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Item Code ${index}`) }}
							</span>
						</td>
						<td v-if="applicationSelected == 'articleMaster'">
							<el-select
								v-model="article.stockComesFrom"
								v-validate="slecteIndex == index ? 'required' : ''"
								style="min-width: 150px;"
								:name="`Stock Comes From ${index}`"
								placeholder="Stock Comes From"
								@change="stockComesFromChanged($event, index)"
							>
								<el-option label="Internal" value="internal" />
								<el-option label="Vendor" value="vendor" />
								<el-option label="Prepared" value="prepared" />
							</el-select>
							<span
								:v-show="errors.has(`Stock Comes From ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Stock Comes From ${index}`) }}
							</span>
						</td>
						<td v-if="applicationSelected == 'articleMaster'">
							<el-select
								v-model="article.forecastType"
								v-validate="slecteIndex == index ? 'required' : ''"
								style="width: 150px;"
								:name="`Forecast Type ${index}`"
								placeholder="Forecast Type"
								@change="forecastTypeChanged($event, index)"
							>
								<el-option
									label="Forecast"
									value="forecast"
									:disabled="article.disableForecastTypeOptions.forecast"
								/>
								<el-option
									label="Manual"
									value="manual"
									:disabled="article.disableForecastTypeOptions.manual"
								/>
							</el-select>
							<span
								:v-show="errors.has(`Forecast Type ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Forecast Type ${index}`) }}
							</span>
						</td>
						<td>
							<el-select
								v-model="article.itemType"
								v-validate="slecteIndex == index ? 'required' : ''"
								style="min-width: 150px;"
								:name="`Item Type ${index}`"
								placeholder="Item Type"
							>
								<el-option
									label="Sku"
									value="sku"
									:disabled="article.disableItemTypeOptions.sku"
								/>
								<el-option
									label="Raw Material"
									value="raw material"
									:disabled="article.disableItemTypeOptions['raw material']"
								/>
								<el-option
									label="Serveware"
									value="serveware"
									:disabled="article.disableItemTypeOptions.serveware"
								/>
								<el-option
									label="Consumable"
									value="consumable"
									:disabled="article.disableItemTypeOptions.consumable"
								/>
								<el-option
									label="Condiments"
									value="condiments"
									:disabled="article.disableItemTypeOptions.condiments"
								/>
								<el-option
									label="Cleaning"
									value="cleaning"
									:disabled="article.disableItemTypeOptions.cleaning"
								/>
								<el-option
									label="Kitchen Equipment"
									value="kitchen equipment"
									:disabled="
										article.disableItemTypeOptions['kitchen equipment']
									"
								/>
								<el-option
									label="Miscellaneous"
									value="miscellaneous"
									:disabled="article.disableItemTypeOptions.miscellaneous"
								/>
								<el-option
									label="Menu item"
									value="menu item"
									:disabled="article.disableItemTypeOptions['menu item']"
								/>
							</el-select>
							<span
								:v-show="errors.has(`Item Type ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Item Type ${index}`) }}
							</span>
						</td>
						<td>
							<el-select
								v-model="article.department"
								v-validate="slecteIndex == index ? 'required' : ''"
								value-key="id"
								filterable
								allow-create
								default-first-option
								:clearable="true"
								style="min-width: 150px;"
								:name="`Department ${index}`"
								placeholder="Department"
								@change="getCategoriesForPartDepartment($event, index)"
							>
								<el-option
									v-for="(department, departmentIndex) in departments"
									:key="departmentIndex"
									:label="department.name"
									:value="department"
								/>
							</el-select>
							<span
								:v-show="errors.has(`Department ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Department ${index}`) }}
							</span>
						</td>
						<td>
							<el-select
								v-model="article.category"
								v-validate="
									slecteIndex == index
										? ['category', 'subcategory'].some(
												v => v === classification
										  )
											? 'required'
											: ''
										: ''
								"
								value-key="id"
								:disabled="permanantDisableCateogry || article.disableCategory"
								filterable
								allow-create
								default-first-option
								:clearable="true"
								style="width: 150px;"
								:name="`Category ${index}`"
								placeholder="Category"
								@change="getSubcategoriesForPartCategory($event, index)"
							>
								<el-option
									v-for="(category, categoryIndex) in article.categories"
									:key="categoryIndex"
									:value="category"
									:label="category.name"
								/>
							</el-select>
							<span
								:v-show="errors.has(`Category ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Category ${index}`) }}
							</span>
						</td>
						<td>
							<el-select
								v-model="article.subcategory"
								v-validate="
									slecteIndex == index
										? ['subcategory'].some(v => v === classification)
											? 'required'
											: ''
										: ''
								"
								value-key="id"
								:disabled="
									permanantDisableSubcategory || article.disableSubcategory
								"
								:clearable="true"
								filterable
								allow-create
								default-first-option
								style="width: 150px;"
								:name="`Subcategory ${index}`"
								placeholder="Subcategory"
								@change="subcategoryChanged($event, index)"
							>
								<el-option
									v-for="(subcategory,
									subcategoryIndex) in article.subcategories"
									:key="subcategoryIndex"
									:label="subcategory.name"
									:value="subcategory"
								/>
							</el-select>
							<span
								:v-show="errors.has(`Subcategory ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Subcategory ${index}`) }}
							</span>
						</td>
						<td v-if="applicationSelected == 'articleMaster'">
							<el-select
								v-model="article.orderUnit"
								v-validate="
									slecteIndex == index
										? article.stockComesFrom === 'internal' ||
										  (article.orderUnit === '' &&
												article.containsEachBase !== '')
											? 'required'
											: ''
										: ''
								"
								style="width: 150px;"
								:name="`Order Unit ${index}`"
								placeholder="Order Unit"
							>
								<el-option label="Box" value="box" />
								<el-option label="Crate" value="crate" />
								<el-option label="Pack" value="pack" />
								<el-option label="Bottle" value="bottle" />
								<el-option label="Kg" value="kg" />
								<el-option label="Gms" value="gms" />
								<el-option label="Litre" value="litre" />
								<el-option label="ml" value="ml" />
								<el-option label="dozen" value="dozen" />
								<el-option label="Numbers" value="numbers" />
								<el-option label="Each" value="each" />
							</el-select>
							<span
								:v-show="errors.has(`Order Unit ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Order Unit ${index}`) }}
							</span>
						</td>
						<td v-if="applicationSelected == 'articleMaster'">
							<BaseInput
								v-model="article.containsEachBase"
								v-validate="
									slecteIndex == index
										? {
												required:
													article.containsEachBase === '' &&
													article.orderUnit !== '',
												min_value: 0
										  }
										: ''
								"
								class="baseInput"
								:name="`Contains Each Base ${index}`"
								custom-class="p-2
							text-sm text-amp-input-boxes"
								placeholder="Contains Each Base"
							/>
							<span
								:v-show="errors.has(`Contains Each Base ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Contains Each Base ${index}`) }}
							</span>
						</td>
						<td v-if="applicationSelected == 'articleMaster'">
							<el-select
								v-model="article.baseUnit"
								v-validate="slecteIndex == index ? 'required' : ''"
								style="width: 150px;"
								:name="`Base Unit ${index}`"
								placeholder="Base Unit"
							>
								<el-option label="Box" value="box" />
								<el-option label="Crate" value="crate" />
								<el-option label="Pack" value="pack" />
								<el-option label="Bottle" value="bottle" />
								<el-option label="Kg" value="kg" />
								<el-option label="Gms" value="gms" />
								<el-option label="Litre" value="litre" />
								<el-option label="ml" value="ml" />
								<el-option label="dozen" value="dozen" />
								<el-option label="Numbers" value="numbers" />
								<el-option label="Each" value="each" />
							</el-select>
							<span
								:v-show="errors.has(`Base Unit ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Base Unit ${index}`) }}
							</span>
						</td>
						<td v-if="applicationSelected == 'articleMaster'">
							<BaseInput
								v-model="article.primaryShelfLife"
								v-validate="
									slecteIndex == index
										? article.stockComesFrom !== 'prepared'
											? 'required|min_value:1'
											: ''
										: ''
								"
								class="baseInput"
								:name="`Primary Shelf Life ${index}`"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Primary Shelf Life"
							/>
							<span
								:v-show="errors.has(`Primary Shelf Life ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Primary Shelf Life ${index}`) }}
							</span>
						</td>
						<td v-if="applicationSelected == 'articleMaster'">
							<BaseInput
								v-model="article.secondaryShelfLife"
								v-validate="
									slecteIndex == index
										? article.stockComesFrom !== 'prepared'
											? 'required|min_value:1'
											: ''
										: ''
								"
								class="baseInput"
								:name="`Secondary Shelf Life ${index}`"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Secondary Shelf Life"
							/>
							<span
								:v-show="errors.has(`Secondary Shelf Life ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Secondary Shelf Life ${index}`) }}
							</span>
						</td>
						<td v-if="applicationSelected == 'articleMaster'">
							<BaseInput
								v-model="article.orderingFrequency"
								v-validate="
									slecteIndex == index
										? article.stockComesFrom !== 'prepared'
											? 'required|min_value:0'
											: ''
										: ''
								"
								class="baseInput"
								:name="`Ordering Frequency ${index}`"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Ordering Frequency"
							/>
							<span
								:v-show="errors.has(`Ordering Frequency ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Ordering Frequency ${index}`) }}
							</span>
						</td>

						<td v-if="applicationSelected == 'articleMaster'">
							<BaseInput
								v-model="article.leadTime"
								v-validate="
									slecteIndex == index
										? article.stockComesFrom !== 'prepared'
											? 'required|numeric'
											: ''
										: ''
								"
								class="baseInput"
								:name="`Lead Time ${index}`"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Lead Time"
							/>
							<span
								:v-show="errors.has(`Lead Time ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Lead Time ${index}`) }}
							</span>
						</td>
						<td v-if="applicationSelected == 'articleMaster'">
							<BaseInput
								v-model="article.serviceLevel"
								v-validate="slecteIndex == index ? 'between:0,100' : ''"
								class="baseInput"
								:name="`Service Level ${index}`"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Service Level"
							/>
							<span
								:v-show="errors.has(`Service Level ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Service Level ${index}`) }}
							</span>
						</td>
						<td v-if="applicationSelected == 'articleMaster'">
							<BaseInput
								v-model="article.minStockLevel"
								v-validate="
									slecteIndex == index
										? {
												required:
													article.forecastType === 'manual' ? true : false,
												numeric: true
										  }
										: ''
								"
								class="baseInput"
								:name="`Stock Level ${index}`"
								custom-class="p-2 text-sm text-amp-input-boxes"
								placeholder="Stock Level"
							/>
							<span
								:v-show="errors.has(`Stock Level ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Stock Level ${index}`) }}
							</span>
						</td>
						<td v-if="applicationSelected == 'articleMaster'">
							<BaseInput
								v-model="article.currentCost"
								v-validate="
									slecteIndex == index
										? {
												required:
													article.stockComesFrom === 'internal' ? true : false,
												min_value: 0
										  }
										: ''
								"
								class="baseInput"
								:name="`Current Cost ${index}`"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Current Cost"
							/>
							<span
								:v-show="errors.has(`Current Cost ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Current Cost ${index}`) }}
							</span>
						</td>
						<td>
							<BaseInput
								v-model="article.salesPrice"
								v-validate="{
									required: article.itemType === 'sku' ? true : false,
									min_value: 0
								}"
								class="baseInput"
								:name="`Sales Price ${index}`"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Sales Price"
							/>
							<span
								:v-show="errors.has(`Sales Price ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Sales Price ${index}`) }}
							</span>
						</td>
						<td v-if="applicationSelected == 'articleMaster'">
							<el-select
								v-model="article.productRemarks"
								style="width: 150px;"
								:name="`Product Remarks ${index}`"
								placeholder="Product Remarks"
							>
								<el-option label="Active" value="active" />
								<el-option label="Inactive" value="inactive" />
							</el-select>
							<span
								:v-show="errors.has(`Product Remarks ${index}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Product Remarks ${index}`) }}
							</span>
						</td>
						<td v-if="editIngredient" style="border-right: none !important;">
							<img
								src="../../assets/images/FEATURES_icons/checkTick.png"
								alt=""
								class="cursor-pointer"
								srcset=""
								@click="editArticle(article, index)"
							/>
						</td>
						<td
							style="text-align:center !important; width: 100px; border-right: none;"
						>
							<img
								src="../../assets/images/delete-icon.png"
								alt=""
								class="cursor-pointer"
								srcset=""
								@click="deleteArticle(article, index)"
							/>
						</td>
					</tr>
				</tbody>
			</table>
		</simplebar> -->
		<template>
			<el-table
				:data="articleMaster"
				style="width: 100%"
				border
				max-height="500"
			>
				<el-table-column width="200" fixed label="Item Description">
					<template slot-scope="scope">
						<BaseInput
							v-model="scope.row.itemDescription"
							v-validate="slecteIndex == scope.$index ? 'required' : ''"
							style="min-width: 190px;"
							:name="`Item Description ${scope.$index}`"
							class="baseInput"
							custom-class="p-2 text-sm text-amp-input-boxes"
							placeholder="Item Description"
						/>
						<span
							:v-show="errors.has(`Item Description ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Item Description ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column width="120" fixed label="Item code">
					<template slot-scope="scope">
						<BaseInput
							v-model="scope.row.itemCode"
							v-validate="
								slecteIndex == scope.$index
									? {
											alpha_num: true,
											unique: [articleMaster, scope.$index]
									  }
									: ''
							"
							style="min-width: 100px;"
							:disabled="scope.row.disableItemCode"
							:name="`Item Code ${scope.$index}`"
							class="baseInput"
							custom-class="p-2 text-sm text-amp-input-boxes"
							placeholder="Item code"
						/>
						<!-- @blur="addToItemCodeDB(scope.$index)" -->
						<span
							:v-show="errors.has(`Item Code ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Item Code ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="applicationSelected == 'articleMaster'"
					width="170"
					label="Stock Comes From"
				>
					<template slot-scope="scope">
						<el-select
							v-model="scope.row.stockComesFrom"
							v-validate="slecteIndex == scope.$index ? 'required' : ''"
							style="min-width: 130px;"
							:name="`Stock Comes From ${scope.$index}`"
							placeholder="Stock Comes From"
							@change="stockComesFromChanged($event, scope.$index)"
						>
							<el-option label="Internal" value="internal" />
							<el-option label="Vendor" value="vendor" />
							<el-option label="Prepared" value="prepared" />
						</el-select>
						<span
							:v-show="errors.has(`Stock Comes From ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Stock Comes From ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="applicationSelected == 'articleMaster'"
					width="180"
					label="Forecast Type"
				>
					<template slot-scope="scope">
						<el-select
							v-model="scope.row.forecastType"
							v-validate="slecteIndex == scope.$index ? 'required' : ''"
							style="width: 160px;"
							:name="`Forecast Type ${scope.$index}`"
							placeholder="Forecast Type"
							@change="forecastTypeChanged($event, scope.$index)"
						>
							<el-option
								label="Forecast"
								value="forecast"
								:disabled="scope.row.disableForecastTypeOptions.forecast"
							/>
							<el-option
								label="Manual"
								value="manual"
								:disabled="scope.row.disableForecastTypeOptions.manual"
							/>
						</el-select>
						<span
							:v-show="errors.has(`Forecast Type ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Forecast Type ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column width="180" label="Item Type">
					<template slot-scope="scope">
						<el-select
							v-model="scope.row.itemType"
							v-validate="slecteIndex == scope.$index ? 'required' : ''"
							style="min-width: 150px;"
							:name="`Item Type ${scope.$index}`"
							placeholder="Item Type"
						>
							<el-option
								label="Sku"
								value="sku"
								:disabled="scope.row.disableItemTypeOptions.sku"
							/>
							<el-option
								label="Raw Material"
								value="raw_material"
								:disabled="scope.row.disableItemTypeOptions['raw_material']"
							/>
							<el-option
								label="Serveware"
								value="serveware"
								:disabled="scope.row.disableItemTypeOptions.serveware"
							/>
							<el-option
								label="Consumable"
								value="consumable"
								:disabled="scope.row.disableItemTypeOptions.consumable"
							/>
							<el-option
								label="Condiments"
								value="condiments"
								:disabled="scope.row.disableItemTypeOptions.condiments"
							/>
							<el-option
								label="Cleaning"
								value="cleaning"
								:disabled="scope.row.disableItemTypeOptions.cleaning"
							/>
							<el-option
								label="Kitchen Equipment"
								value="kitchen equipment"
								:disabled="
									scope.row.disableItemTypeOptions['kitchen equipment']
								"
							/>
							<el-option
								label="Miscellaneous"
								value="miscellaneous"
								:disabled="scope.row.disableItemTypeOptions.miscellaneous"
							/>
							<el-option
								label="Menu item"
								value="menu item"
								:disabled="scope.row.disableItemTypeOptions['menu item']"
							/>
							<el-option value="intermediate" label="Intermediate">
								Intermediate
							</el-option>
						</el-select>
						<span
							:v-show="errors.has(`Item Type ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Item Type ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column width="180" label="Department">
					<template slot-scope="scope">
						<el-select
							v-model="scope.row.department"
							v-validate="slecteIndex == scope.$index ? 'required' : ''"
							value-key="id"
							filterable
							allow-create
							default-first-option
							:clearable="true"
							style="min-width: 150px;"
							:name="`Department ${scope.$index}`"
							placeholder="Department"
							@change="getCategoriesForPartDepartment($event, scope.$index)"
						>
							<el-option
								v-for="(department, departmentIndex) in departments"
								:key="departmentIndex"
								:label="department.name"
								:value="department"
							/>
						</el-select>
						<span
							:v-show="errors.has(`Department ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Department ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column width="180" label="category">
					<template slot-scope="scope">
						<el-select
							v-model="scope.row.category"
							v-validate="
								slecteIndex == scope.$index
									? ['category', 'subcategory'].some(v => v === classification)
										? 'required'
										: ''
									: ''
							"
							value-key="id"
							:disabled="permanantDisableCateogry || scope.row.disableCategory"
							filterable
							allow-create
							default-first-option
							:clearable="true"
							style="width: 150px;"
							:name="`Category ${scope.$index}`"
							placeholder="Category"
							@change="getSubcategoriesForPartCategory($event, scope.$index)"
						>
							<el-option
								v-for="(category, categoryIndex) in scope.row.categories"
								:key="categoryIndex"
								:value="category"
								:label="category.name"
							/>
						</el-select>
						<span
							:v-show="errors.has(`Category ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Category ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column width="180" label="Subcategory">
					<template slot-scope="scope">
						<el-select
							v-model="scope.row.subcategory"
							v-validate="
								slecteIndex == scope.$index
									? ['subcategory'].some(v => v === classification)
										? 'required'
										: ''
									: ''
							"
							value-key="id"
							:disabled="
								permanantDisableSubcategory || scope.row.disableSubcategory
							"
							:clearable="true"
							filterable
							allow-create
							default-first-option
							style="width: 150px;"
							:name="`Subcategory ${scope.$index}`"
							placeholder="Subcategory"
							@change="subcategoryChanged($event, scope.$index)"
						>
							<el-option
								v-for="(subcategory, subcategoryIndex) in scope.row
									.subcategories"
								:key="subcategoryIndex"
								:label="subcategory.name"
								:value="subcategory"
							/>
						</el-select>
						<span
							:v-show="errors.has(`Subcategory ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Subcategory ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="applicationSelected == 'articleMaster'"
					width="180"
					label="Order Unit"
				>
					<template slot-scope="scope">
						<el-select
							v-model="scope.row.orderUnit"
							v-validate="
								slecteIndex == scope.$index
									? scope.row.stockComesFrom === 'internal' ||
									  (scope.row.orderUnit === '' &&
											scope.row.containsEachBase !== '')
										? 'required'
										: ''
									: ''
							"
							style="width: 150px;"
							:name="`Order Unit ${scope.$index}`"
							placeholder="Order Unit"
						>
							<el-option label="Box" value="box" />
							<el-option label="Crate" value="crate" />
							<el-option label="Pack" value="pack" />
							<el-option label="Bottle" value="bottle" />
							<el-option label="Kg" value="kg" />
							<el-option label="Gms" value="gms" />
							<el-option label="Litre" value="litre" />
							<el-option label="ml" value="ml" />
							<el-option label="dozen" value="dozen" />
							<el-option label="Numbers" value="numbers" />
							<el-option label="Each" value="each" />
						</el-select>
						<span
							:v-show="errors.has(`Order Unit ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Order Unit ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="applicationSelected == 'articleMaster'"
					width="130"
					label="Contains Each Base"
				>
					<template slot-scope="scope">
						<BaseInput
							v-model="scope.row.containsEachBase"
							v-validate="
								slecteIndex == scope.$index
									? {
											required:
												scope.row.containsEachBase === '' &&
												scope.row.orderUnit !== '',
											min_value: 0
									  }
									: ''
							"
							class="baseInput"
							:name="`Contains Each Base ${scope.$index}`"
							custom-class="p-2
							text-sm text-amp-input-boxes"
							placeholder="Contains Each Base"
						/>
						<span
							:v-show="errors.has(`Contains Each Base ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Contains Each Base ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="applicationSelected == 'articleMaster'"
					width="180"
					label="Base Unit"
				>
					<template slot-scope="scope">
						<el-select
							v-model="scope.row.baseUnit"
							v-validate="slecteIndex == scope.$index ? 'required' : ''"
							style="width: 150px;"
							:name="`Base Unit ${scope.$index}`"
							placeholder="Base Unit"
						>
							<el-option label="Box" value="box" />
							<el-option label="Crate" value="crate" />
							<el-option label="Pack" value="pack" />
							<el-option label="Bottle" value="bottle" />
							<el-option label="Kg" value="kg" />
							<el-option label="Gms" value="gms" />
							<el-option label="Litre" value="litre" />
							<el-option label="ml" value="ml" />
							<el-option label="dozen" value="dozen" />
							<el-option label="Numbers" value="numbers" />
							<el-option label="Each" value="each" />
						</el-select>
						<span
							:v-show="errors.has(`Base Unit ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Base Unit ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="applicationSelected == 'articleMaster'"
					width="180"
					label="Minimum Order Qty (In Order Unit)"
				>
					<template slot-scope="scope">
						<BaseInput
							v-model="scope.row.min_order_quantity"
							v-validate="
								slecteIndex == scope.$index
									? 'required|min_value:0|numeric'
										: ''
							"
							type="number"
							:name="`Minimum Order Qty ${scope.$index}`"
							custom-class="p-2 text-sm  text-amp-input-boxes"
							placeholder="Minimum Order Qty"
						/>
						<span
							:v-show="errors.has(`Minimum Order Qty ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Minimum Order Qty ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="applicationSelected == 'articleMaster'"
					width="130"
					label="Rounding Qty (In Order Unit)"
				>
					<template slot-scope="scope">
						<BaseInput
							v-model="scope.row.rounding_quantity"
							v-validate="
								slecteIndex == scope.$index
									? 'required|min_value:0|numeric'
										: ''
							"
							type="number"
							class="baseInput"
							:name="`Rounding Qty ${scope.$index}`"
							custom-class="p-2 text-sm  text-amp-input-boxes"
							placeholder="Rounding Qty"
						/>
						<span
							:v-show="errors.has(`Rounding Qty ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Rounding Qty ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="applicationSelected == 'articleMaster'"
					width="130"
					label="Primary Shelf Life"
				>
					<template slot-scope="scope">
						<BaseInput
							v-model="scope.row.primaryShelfLife"
							v-validate="
								slecteIndex == scope.$index
									? scope.row.stockComesFrom !== 'prepared'
										? 'required|min_value:1'
										: ''
									: ''
							"
							class="baseInput"
							:name="`Primary Shelf Life ${scope.$index}`"
							custom-class="p-2 text-sm  text-amp-input-boxes"
							placeholder="Primary Shelf Life"
						/>
						<span
							:v-show="errors.has(`Primary Shelf Life ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Primary Shelf Life ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="applicationSelected == 'articleMaster'"
					width="130"
					label="Secondary Shelf Life"
				>
					<template slot-scope="scope">
						<BaseInput
							v-model="scope.row.secondaryShelfLife"
							v-validate="
								slecteIndex == scope.$index
									? scope.row.stockComesFrom !== 'prepared'
										? 'required|min_value:1'
										: ''
									: ''
							"
							class="baseInput"
							:name="`Secondary Shelf Life ${scope.$index}`"
							custom-class="p-2 text-sm  text-amp-input-boxes"
							placeholder="Secondary Shelf Life"
						/>
						<span
							:v-show="errors.has(`Secondary Shelf Life ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Secondary Shelf Life ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="applicationSelected == 'articleMaster'"
					width="130"
					label="Ordering Frequency"
				>
					<template slot-scope="scope">
						<BaseInput
							v-model="scope.row.orderingFrequency"
							v-validate="
								slecteIndex == scope.$index
									? scope.row.stockComesFrom !== 'prepared'
										? 'required|min_value:0'
										: ''
									: ''
							"
							class="baseInput"
							:name="`Ordering Frequency ${scope.$index}`"
							custom-class="p-2 text-sm  text-amp-input-boxes"
							placeholder="Ordering Frequency"
						/>
						<span
							:v-show="errors.has(`Ordering Frequency ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Ordering Frequency ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="applicationSelected == 'articleMaster'"
					width="130"
					label="Lead Time"
				>
					<template slot-scope="scope">
						<BaseInput
							v-model="scope.row.leadTime"
							v-validate="
								slecteIndex == scope.$index
									? scope.row.stockComesFrom !== 'prepared'
										? 'required|numeric'
										: ''
									: ''
							"
							class="baseInput"
							:name="`Lead Time ${scope.$index}`"
							custom-class="p-2 text-sm  text-amp-input-boxes"
							placeholder="Lead Time"
						/>
						<span
							:v-show="errors.has(`Lead Time ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Lead Time ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="applicationSelected == 'articleMaster'"
					width="130"
					label="Service Level"
				>
					<template slot-scope="scope">
						<BaseInput
							v-model="scope.row.serviceLevel"
							v-validate="slecteIndex == scope.$index ? 'between:0,100' : ''"
							class="baseInput"
							:name="`Service Level ${scope.$index}`"
							custom-class="p-2 text-sm  text-amp-input-boxes"
							placeholder="Service Level"
						/>
						<span
							:v-show="errors.has(`Service Level ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Service Level ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="applicationSelected == 'articleMaster'"
					width="130"
					label="Min Stock Level"
				>
					<template slot-scope="scope">
						<BaseInput
							v-model="scope.row.minStockLevel"
							v-validate="
								slecteIndex == scope.$index
									? {
											required:
												scope.row.forecastType === 'manual' ? true : false,
											numeric: true
									  }
									: ''
							"
							class="baseInput"
							:name="`Stock Level ${scope.$index}`"
							custom-class="p-2 text-sm text-amp-input-boxes"
							placeholder="Stock Level"
						/>
						<span
							:v-show="errors.has(`Stock Level ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Stock Level ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="applicationSelected == 'articleMaster'"
					width="130"
					label="Current Cost"
				>
					<template slot-scope="scope">
						<BaseInput
							v-model="scope.row.currentCost"
							v-validate="
								slecteIndex == scope.$index
									? {
											required:
												scope.row.stockComesFrom === 'internal' ? true : false,
											min_value: 0
									  }
									: ''
							"
							class="baseInput"
							:name="`Current Cost ${scope.$index}`"
							custom-class="p-2 text-sm  text-amp-input-boxes"
							placeholder="Current Cost"
						/>
						<span
							:v-show="errors.has(`Current Cost ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Current Cost ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column width="130" label="Sales Price">
					<template slot-scope="scope">
						<BaseInput
							v-model="scope.row.salesPrice"
							v-validate="{
								required: scope.row.itemType === 'sku' ? true : false,
								min_value: 0
							}"
							class="baseInput"
							:name="`Sales Price ${scope.$index}`"
							custom-class="p-2 text-sm  text-amp-input-boxes"
							placeholder="Sales Price"
						/>
						<span
							:v-show="errors.has(`Sales Price ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Sales Price ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column width="180" label="Type of Product">
					<template slot-scope="scope">
						<el-select
							v-model="scope.row.availability_type"
							style="width: 150px;"
							:name="`productType ${scope.$index}`"
							:disabled="scope.row.article_type != 'menu_item'"
							placeholder="productType"
						>
							<el-option label="Regular" value="regular"/>
							<el-option label="LTO" value="LTO"/>
							<el-option label="Seasonal" value="Seasonal"/>
						</el-select>
						<span
							:v-show="errors.has(`productType ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`productType ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column width="180" label="Start Date">
					<template slot-scope="scope">
						<el-date-picker
							v-model="scope.row.availability_type_start"
							type="date"
							value-format="yyyy-MM-dd"
							class="custom-input"
							style="width: 100%;"
							:disabled="scope.row.article_type != 'menu_item'"
							:name="`Start Date ${scope.$index}`"
							placeholder="Start Date"
						>
						</el-date-picker>
						<span
							:v-show="errors.has(`Start Date ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Start Date ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column width="180" label="End Date">
					<template slot-scope="scope">
						<el-date-picker
							v-model="scope.row.availability_type_end"
							type="date"
							value-format="yyyy-MM-dd"
							class="custom-input"
							style="width: 100%;"
							:disabled="scope.row.article_type != 'menu_item'"
							:name="`End Date ${scope.$index}`"
							placeholder="End Date"
						>
						</el-date-picker>
						<span
							:v-show="errors.has(`End Date ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`End Date ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					width="180"
					label="Status"
				>
					<template slot-scope="scope">
						<el-select
							v-model="scope.row.status"
							style="width: 150px;"
							:name="`Status ${scope.$index}`"
							placeholder="Status"
						>
							<el-option label="Active" :value="true" />
							<el-option label="Inactive" :value="false" />
						</el-select>
						<span
							:v-show="errors.has(`Status ${scope.$index}`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`Status ${scope.$index}`) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column width="100" label="">
					<template slot-scope="scope">
						<div class="action-icon">
							<img
								src="../../assets/images/FEATURES_icons/checkTick.png"
								alt=""
								class="cursor-pointer mr-4"
								srcset=""
								@click="editArticle(scope.row, scope.$index)"
							/>
							<img
								src="../../assets/images/delete-icon.png"
								alt=""
								class="cursor-pointer"
								srcset=""
								width="20px"
								height="25px"
								@click="deleteArticle(scope.row, scope.$index)"
							/>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</template>
		<div class="">
			<el-row>
				<el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="24">
					<div v-if="addIngredient" class="mt-4 text-center">
						<BaseButton
							class="mr-8 w-32"
							buttonclass="btn py-1.5 px-4 text-sm"
							@click="articleMaster.push(addArticleMasterToList())"
						>
							Add More
						</BaseButton>
					</div>
					<div v-else>
						&nbsp;
					</div>
				</el-col>
				<el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="24">
					<div class="flex md:justify-end align-start md:flex-row flex-col">
						<BaseButton
							v-if="addIngredient"
							class="w-32 mt-4"
							buttonclass="btn py-1.5 px-4 text-sm"
							@click="$emit('createArticles', articleMaster, departments)"
						>
							Save
						</BaseButton>
						<div v-if="editIngredient" class="mt-4">
							<el-pagination
								background
								:current-page.sync="pageInfo.currentPage"
								:page-sizes="[5, 10, 15]"
								:page-size.sync="pageInfo.pageSize"
								layout="sizes, prev, pager, next"
								:total="pageInfo.totalCount"
								@size-change="handlePageInfoChange"
								@current-change="handlePageInfoChange"
							/>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import "../../customValidations/articleMaster.validations";
import ArticleMasterService from "../../services/articleMasterService";
import CommonService from "../../services/commonService";
import { ArticleMasterMixin } from "../../../mixins/articleMaster.mixin";
import { Promise, resolve, async } from "q";

const productItemTypes = ["sku", "raw material", "menu item"];
const nonProductItemTypes = [
	"serveware",
	"consumable",
	"condiments",
	"cleaning",
	"kitchen equipment",
	"miscellaneous"
];
export default {
	name: "BaseArticleMasterTable",
	inject: ["$validator"],
	components: {
		// simplebar
	},
	mixins: [ArticleMasterMixin],
	props: {
		addIngredient: {
			type: Boolean,
			default: false
		},
		editIngredient: {
			type: Boolean,
			default: false
		},
		applicationSelected: {
			type: String,
			default: () => ""
		},
		articleMaster: {
			type: Array,
			default: () => []
		},
		pageInfo: {
			type: Object,
			default: () => {}
		},
		handlePageInfoChange: {
			type: Function,
			default: () => null
		}
	},
	data() {
		return {
			id: 0,
			departments: [],
			slecteIndex: null,
			classification: null
		};
	},
	computed: {
		permanantDisableCateogry() {
			if (
				this.classification === "category" ||
				this.classification === "subcategory" ||
				this.classification === null
			) {
				return false;
			}
			return true;
		},
		permanantDisableSubcategory() {
			if (
				this.classification === "subcategory" ||
				this.classification === null
			) {
				return false;
			}
			return true;
		}
		// asyncDisableCategory() {
		// 	// eslint-disable-next-line vue/no-async-in-computed-properties
		// 	return async index => {
		// 		var status;
		// 		if (this.departments[index].id !== "") {
		// 			status = await this.doesDepartmentExist(this.departments[index].id);
		// 			if (status) return true;
		// 		}
		// 		return false;
		// 	};
		// },
		// stockComesFrom() {
		// 	return this.articleMaster.map(article => article.stockComesFrom);
		// }
	},
	watch: {
		// articleMaster: {
		// 	handler: function(val) {
		// 		console.log(val);
		// 	},
		// 	deep: true
		// },
		// stockComesFrom(stockComesFromList) {
		// 	console.log(stockComesFromList);
		// 	stockComesFromList.forEach((stockComesFrom, index) => {
		// 		if (stockComesFrom === "prepared") {
		// 			this.articleMaster[index].itemType = "product";
		// 			this.articleMaster[index].disableItemType = true;
		// 		} else {
		// 			this.articleMaster[index].disableItemType = false;
		// 		}
		// 	});
		// }
	},

	created() {
		// start by creating function when subcategory changes.
		this.setArticleClassification();
		this.getDepartments({ get_all: true });
		if (this.$route.name === "AddArticleMaster") {
			for (let i = 0; i < 1; i++) {
				this.articleMaster.push(this.addArticleMasterToList());
			}
		}
	},
	methods: {
		deleteArticle(article, index) {
			if (this.editIngredient) {
				this.$emit("deleteArticleFromServer", article, index);
			} else {
				this.$emit("removeArticleFromList", index);
			}
			// try {
			// 	await ArticleMasterService.deleteArticle({outletId: this.})
			// } catch (err) {
			// 	console.log(err);
			// }
		},
		editArticle(article, index) {
			this.slecteIndex = index;
			if(this.articleMaster[index].minStockLevel == 0 && this.articleMaster[index].forecastType == "manual") {
				this.$confirm('<b>Min Stock Level</b> for the item cannot be 0 if the <b>Forcast Type</b> is set to Manual <br> <br>' , 'Alert', {
						confirmButtonText: 'OK',
						showCancelButton: false,
						dangerouslyUseHTMLString: true
						}).then(() => {
						}).catch(() => {
						});
			} else {
				setTimeout(() => {
					this.$emit("editArticle", article);
				}, 100);
			}
		},
		async setArticleClassification() {
			try {
				await CommonService.getArticleClassification().then(response => {
					if (response.status === 200) {
						let classification = JSON.parse(response.data).message;
						console.log("classification", classification);
						this.classification = classification;
					}
				});
			} catch (err) {
				console.log(err);
			}
		},
		forecastTypeChanged(forecastType, index) {
			if (forecastType === "manual") {
				// disable items of product type.
				this.articleMaster[index].disableItemTypeOptions.sku = true;
				this.articleMaster[index].disableItemTypeOptions["raw material"] = true;
				this.articleMaster[index].disableItemTypeOptions.serveware = false;
				this.articleMaster[index].disableItemTypeOptions.consumable = false;
				this.articleMaster[index].disableItemTypeOptions.condiments = false;
				this.articleMaster[index].disableItemTypeOptions.cleaning = false;
				this.articleMaster[index].disableItemTypeOptions[
					"kitchen equipment"
				] = false;
				this.articleMaster[index].disableItemTypeOptions.miscellaneous = false;
				this.articleMaster[index].disableItemTypeOptions["menu item"] = true;
				this.$confirm('please set the reorder point for the item by adding <b>Min Stock Level</b> value <br> <br>' , 'Alert', {
					confirmButtonText: 'OK',
					showCancelButton: false,
					dangerouslyUseHTMLString: true
					}).then(() => {
					}).catch(() => {
					});
			} else {
				if (this.articleMaster[index].stockComesFrom !== "prepared") {
					// if stock comes from is not prepared
					// and forecast type is not manual
					// then enable all item type options.
					this.resetItemTypeDisabled(index);
				}
			}
			this.resetItemTypeIfNotInArray(productItemTypes, index);
		},

		stockComesFromChanged(stockComesFrom, index) {
			if (stockComesFrom === "prepared") {
				// disable manual forecast type.
				this.articleMaster[index].disableForecastTypeOptions.manual = true;
				// disable items other than that of product type.
				this.articleMaster[index].disableItemTypeOptions.sku = false;
				this.articleMaster[index].disableItemTypeOptions[
					"raw material"
				] = false;
				this.articleMaster[index].disableItemTypeOptions.serveware = true;
				this.articleMaster[index].disableItemTypeOptions.consumable = true;
				this.articleMaster[index].disableItemTypeOptions.condiments = true;
				this.articleMaster[index].disableItemTypeOptions.cleaning = true;
				this.articleMaster[index].disableItemTypeOptions[
					"kitchen equipment"
				] = true;
				this.articleMaster[index].disableItemTypeOptions.miscellaneous = true;
				this.articleMaster[index].disableItemTypeOptions["menu item"] = false;

				if (this.articleMaster[index].forecastType === "manual") {
					// empty forecast type if manual is already selected.
					this.articleMaster[index].forecastType = "";
				}
			} else {
				this.articleMaster[index].disableForecastTypeOptions.manual = false;
				this.resetItemTypeDisabled(index);
			}
			this.resetItemTypeIfNotInArray(nonProductItemTypes, index);
		},
		resetItemTypeIfNotInArray(arr, index) {
			if (arr.some(val => val === this.articleMaster[index].itemType)) {
				this.articleMaster[index].itemType = "";
			}
		},
		resetItemTypeDisabled(index) {
			console.log("inside resetItemTypeDisabled", index);
			this.articleMaster[index].disableItemTypeOptions.sku = false;
			this.articleMaster[index].disableItemTypeOptions["raw material"] = false;
			this.articleMaster[index].disableItemTypeOptions.serveware = false;
			this.articleMaster[index].disableItemTypeOptions.consumable = false;
			this.articleMaster[index].disableItemTypeOptions.condiments = false;
			this.articleMaster[index].disableItemTypeOptions.cleaning = false;
			this.articleMaster[index].disableItemTypeOptions[
				"kitchen equipment"
			] = false;
			this.articleMaster[index].disableItemTypeOptions.miscellaneous = false;
			this.articleMaster[index].disableItemTypeOptions["menu item"] = false;
		},

		async getCategoriesForPartDepartment(department, index) {
			this.articleMaster[index].category = ""; // clear when department changes;
			this.articleMaster[index].subcategory = ""; // clear when department changes;
			this.articleMaster[index].categories = []; // empty categories when department changes.
			this.articleMaster[index].subcategories = []; // empty sub categories when department changes.
			this.articleMaster[index].addNewDepartment = false; // key used to create department when true.
			this.articleMaster[index].addNewCategory = false; // key used to create category when true.
			this.articleMaster[index].addNewSubcategory = false; // key used to create sub category when true.
			this.articleMaster[index].disableCategory = true;
			this.articleMaster[index].disableSubcategory = true;
			if (department !== "") {
				let departmentId = department.id || department;
				if (await this.doesDepartmentExist(departmentId)) {
					if (
						this.classification === "category" ||
						this.classification === "subcategory"
					) {
						// enable category if classification is category or subcategory
						this.articleMaster[index].disableCategory = false;
						// this.articleMaster[index].disableSubcategory = false;
						// if department exists and the article classification is category or subcategory call getCategories.
						this.articleMaster[index].categories = await this.getAllCategories({
							departmentId: department.id
						}).then(v => resolve(v));
					}
				} else {
					this.articleMaster[index].addNewDepartment = true;
					this.articleMaster[index].disableCategory = false; // enable category DD as new hierarchy can be created if new department is created.
					this.articleMaster[index].disableSubcategory = false; // enable sub category DD as new hierarchy can be created if new department is created.
				}
			}
		},
		async getSubcategoriesForPartCategory(category, index) {
			this.articleMaster[index].subcategory = ""; // clear when department changes;
			this.articleMaster[index].subcategories = [];
			this.articleMaster[index].addNewCategory = false;
			this.articleMaster[index].addNewSubcategory = false;
			this.articleMaster[index].disableSubcategory = true;
			if (category !== "") {
				let categoryId = category.id || category;
				if (await this.doesCategoryExist(categoryId)) {
					if (this.classification === "subcategory") {
						// enable subcategory dd if classification is subcategory.
						this.articleMaster[index].disableSubcategory = false;

						// if classification is subcategory and category exists then only call below api.
						this.articleMaster[
							index
						].subcategories = await this.getAllSubcategories({
							categoryId: category.id
						}).then(v => resolve(v));
					}
				} else {
					// this.articleMaster[index].subcategories = [];
					this.articleMaster[index].addNewCategory = true; //enable the disabled select box of subcategory
					this.articleMaster[index].disableSubcategory = false; // enable sub category DD as new hierarchy can be created if new category is created.
				}
			}
		},
		async subcategoryChanged(subcategory, index) {
			this.articleMaster[index].addNewSubcategory = false;

			if (subcategory !== "") {
				let subcategoryId = subcategory.id || subcategory;
				if (!(await this.doesSubcategoryExist(subcategoryId))) {
					this.articleMaster[index].addNewSubcategory = true;
				}
			}
		},
		getDepartments(args) {
			ArticleMasterService.getDepartments(args)
				.then(response => {
					this.departments = JSON.parse(response.data);
				})
				.catch(err => {
					console.log(err);
				});
		},
		addArticleMasterToList() {
			this.id += 1;
			return {
				itemDescription: "",
				itemCode: "",
				itemType: "",
				department: "",
				category: "",
				subcategory: "",
				orderUnit: "",
				containsEachBase: "",
				baseUnit: "",
				primaryShelfLife: "",
				secondaryShelfLife: "",
				orderingFrequency: "",
				forecastType: "",
				leadTime: "",
				serviceLevel: "",
				currentCost: "",
				salesPrice: "",
				productRemarks: "",
				stockComesFrom: "",
				minStockLevel: "",
				addNewDepartment: false,
				addNewCategory: false,
				disableCategory: true,
				categories: [],
				addNewSubcategory: false,
				disableSubcategory: true,
				subcategories: [],
				id: this.id,
				disableForecastTypeOptions: {
					manual: false,
					forecast: false
				},
				disableItemTypeOptions: {
					sku: false,
					"raw material": false,
					serveware: false,
					consumable: false,
					condiments: false,
					cleaning: false,
					"kitchen equipment": false,
					miscellaneous: false,
					"menu item": false
				},
				disableItemCode: false
			};
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./BaseArticleMasterTable.scss";
</style>

<style>
.AppLayout .el-select .el-input.is-focus .el-input__inner {
	overflow: scroll;
}
.AppLayout .el-input__inner,
.Baseinput input {
	/* text-transform: capitalize; */
}
.el-table th > .cell {
	word-break: break-word;
	text-align: center;
	font: Bold 13px/13px "Avenir", Helvetica, Arial, sans-serif !important;
	color: #707070 !important;
	text-transform: uppercase;
}
.el-table--border td,
.el-table--border th {
	border-right: none;
}
th.is-leaf {
	background-color: #f2f2f2;
}
.el-message-box__title {
	color: white;
}

.el-message-box__header {
	background-color: #32343d;
	border: #32343d;
}
/* .el-button--primary {
	background-color: #e6a23c;
    border-color: #e6a23c;
} */

.el-message-box {
	border: none;
	width: 500px !important;
}

</style>
